import { Mic } from "lucide-react";
import Tag from "@/assets/icons/ProductTag.svg";
import DetailBadge from "@/components/ui/DetailBadge";
import { TProductInfo } from "@/types/projectType";

const ProductDetailsModal = ({
  productInfo,
  orderCurrency,
}: {
  orderCurrency: string;
  productInfo: TProductInfo[];
}) => {
  return (
    <div className="space-y-[11px]">
      {productInfo.map((product, i) => (
        <div className="space-y-[11px]" key={i}>
          <div className="flex items-center gap-x-5">
            <h2 className="text-[20px] font-semibold leading-[28px]">
              {product.name}
            </h2>
            <p className="px-2.5 flex gap-x-0.5 items-center py-0.5 border border-[#17457D17] bg-[#f3f3f3] text-gray-600 w-fit font-medium text-[10px] rounded-full">
              <Tag /> {product?.type}
            </p>
          </div>
          <div className="w-[222px] border-[#BBC0C7] border rounded-[8px] overflow-hidden">
            <img
              className="w-full object-cover"
              src={product?.image?.live_url as string}
              alt=""
            />
          </div>
          <DetailBadge title="Description" desc={product.desc} />
          <div className="h-[1px] w-full bg-[#E5E9EB]" />

          <div className="flex justify-between flex-wrap">
            <DetailBadge
              title="Product Requirement"
              desc={product.requiresModeling ? "Modeling" : ""}
            />
            {product.cost !== undefined && (
              <DetailBadge
                title="Product Cost"
                desc={`${orderCurrency} ${product.cost}`}
              />
            )}
            <DetailBadge
              title="Product Category"
              desc={product.category?.title as string}
            />
            <DetailBadge
              isLink={true}
              title="Product Homepage"
              desc={product?.url as string}
            />
            {product.additionalComment && (
              <DetailBadge
                title="Additional Comments"
                desc={product.additionalComment}
              />
            )}
          </div>

          {product.pronunciation?.live_url && (
            <div>
              <h3 className="font-medium text-[#98A2B3] text-[14px] mb-2">
                Product Name Pronunciation
              </h3>
              <div className="flex items-center gap-2 rounded-lg border border-[#E5E9EB] bg-[#F9FAFB] px-3 py-2">
                <Mic className="size-4 shrink-0 text-[#667085]" />
                <audio
                  controls
                  src={product.pronunciation.live_url as string}
                  className="h-8 w-full"
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProductDetailsModal;
